export default __webpack_public_path__ + "static/media/call.7e319855.svg";